import * as Yup from "yup";

export const signInValidation = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(4, "Must be greater then 4")
    .required("Password is required"),
});
